var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.available),expression:"available"}],staticClass:"chart teste"},[_c('canvas',{attrs:{"id":"company-chart"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }